import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Users, Zap, BarChart3, Globe, } from 'lucide-react';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-logo">
          <img src="/KM01.png" alt="Kenny Miles Exchange Logo" />
        </div>
        <div className="hero-content">
        <h1>Your Trusted Cryptocurrency Exchange</h1>
          <p>Experience the future of digital asset trading with Kenny Miles Exchange. We specialize exclusively in cryptocurrency markets, offering you the most secure, reliable, and user-friendly platform for your digital asset investments.</p>
          <div className="hero-buttons">
            <Link to="/trading" className="btn btn-primary">Start Trading</Link>
            <Link to="/about" className="btn btn-secondary">Learn More</Link>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">Why Choose Kenny Miles Exchange?</h2>
          <p className="section-subtitle">
            We provide cutting-edge cryptocurrency trading solutions with unmatched security and reliability
          </p>
          
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <Shield />
              </div>
              <h3>Secure Trading</h3>
              <p>Advanced security protocols and encryption to protect your digital assets and transactions.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <img src="/KM01.png" alt="Kenny Miles Exchange" className="feature-logo" />
              </div>
              <h3>Advanced Analytics</h3>
              <p>Real-time crypto market data and sophisticated trading tools to maximize your success.</p>
            </div>
            
            <div className="feature-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <Users />
                </div>
                <h3>Expert Support</h3>
                <p>24/7 customer support from our team of cryptocurrency trading professionals.</p>
              </div>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <Zap />
              </div>
              <h3>Lightning Fast</h3>
              <p>High-frequency trading capabilities with minimal latency for optimal crypto execution.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <BarChart3 />
              </div>
              <h3>Market Insights</h3>
              <p>Comprehensive crypto market analysis and predictive tools to guide your decisions.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <Globe />
              </div>
              <h3>Global Access</h3>
              <p>Trade cryptocurrencies from anywhere in the world with our mobile-first platform.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="stats-section">
        <div className="container">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">1.5K+</div>
              <div className="stat-label">Active Users</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">$10K+</div>
              <div className="stat-label">Trading Volume</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">5+</div>
              <div className="stat-label">Countries</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">99.9%</div>
              <div className="stat-label">Uptime</div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section">
        <div className="container">
          <div className="cta-content text-center">
            <h2>Ready to Start Your Crypto Trading Journey?</h2>
            <p className="mb-6">
              Join thousands of traders who trust Kenny Miles Exchange for their cryptocurrency success.
            </p>
            <div className="hero-buttons">
              <Link to="/trading" className="btn btn-primary">
                Get Started Today
              </Link>
              <Link to="/reviews" className="btn btn-outline">
                Read Reviews
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 